import { twx } from '~/utils/twx';

export const Badge = twx.span`bg-active typography text-default absolute top-0 right-0 translate-x-[40%] -translate-y-[50%] rounded-full px-[0.375rem] text-sm shadow-[0_0_2px_1px_rgba(0,0,0,0.5)] text-shadow-[0px_0px_3px_#000000]`;
